import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import { createPinia } from "pinia";
import { getSysInfo, getProjectList } from "./api/request.js";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

const initApp = async () => {
    const app = createApp(App);
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedstate);
    app.use(pinia);
    app.use(router);

    // 获取系统信息
    const sysRes = await getSysInfo();
    let sysInfo = sysRes?.data?.data || {};
    document.title = sysInfo.sysName || 'XI DEMO';
    window.sysInfo = sysInfo;

    // 预先加载项目列表
    const { sysStore } = await import("./stores/sysStore.js");
    const store = sysStore();
    const projectRes = await getProjectList();
    if (projectRes?.data?.success) {
        let obj = projectRes.data.data;
        let menuList = [];
        Object.keys(obj).forEach(key => {
            menuList.push({
                name: key,
                projectList: obj[key],
            })
        })
        menuList.forEach(item => {
            item.projectList.forEach(project => {
                project.img = `${sysInfo.baseUrl || ''}/files${project.img}`;
            })
        })
        store.setMenuList(menuList);
    }

    app.mount("#app");
}

initApp();